import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GlobalOutlined } from '@ant-design/icons';
import { Layout, Select } from 'antd';
import NETS from "vanta/dist/vanta.net.min";
import * as THREE from 'three';

import LoginForm from '@src/Layouts/LoginLayout/component/LoginForm';
import CreateAccountForm from '@src/Layouts/LoginLayout/component/CreateAccountForm';
import ForgotPWDForm from '@src/Layouts/LoginLayout/component/ForgotPWDForm';
import { getOperatorInfo } from '@src/services/companyInformation';

import { UserInfoStore } from '@src/store/UserInfoData/Provider';

import styles from './styles.module.less';

const LoginLayout = () => {
  const { t, i18n } = useTranslation();

  const { state, dispatch } = React.useContext(UserInfoStore);
  const location = useLocation();

  React.useEffect(() => {
    // if(process.env.VERSION !== localStorage.getItem('VERSION')){
    //   localStorage.setItem('VERSION', process.env.VERSION);
    //   window.location.reload();
    // }

    onPlatformLogo();
    document.body.style.height = '100vh';
    const vantDom = NETS({
      el: document.body,
      THREE: THREE,
      scale: 1.0,
      scaleMobile: 1.0,
      backgroundColor: 0x10101,
      color: 0x3a86f2,
      spacing: 20.0,
      points: 8.0,
      maxDistance: 30.0,
      showDots: false
    });

    return () => {
      if (vantDom) vantDom.destroy()
    }
  }, [])

  const defaultLangValue = () => {
    const lang = sessionStorage.getItem('oper_lang');

    switch (lang) {
      case 'en_US':
        return 'Intl-English';
      case 'zh_CN':
        return 'Intl-简体中文';
      // case 'zh_XG':
      //   return 'Intl-繁體中文';
      default:
        return 'Intl-简体中文';
    }
  }

  const onLangChange = (lang) => {
    i18n.changeLanguage(lang);
    sessionStorage.setItem('oper_lang', lang);
  }

  const onPlatformLogo = async () => {
    const res = await getOperatorInfo();

    dispatch({
      type: 'SET_COMPANY_LOGO',
      payload: res.lightLogo ? `/api${res.lightLogo}?sign=${process.env.SIGN}&appid=${process.env.APPID}&timestamp=${process.env.TIMESTAMP}&_=${new Date().getTime()}` : ''
    })
  }

  return (
    <div className={styles.login_layout}>
      <Layout>
        <Layout.Header className={styles.header}>
          <div className={styles.logo}>
            {/* <img
              src={state.companyLogo}
              alt=""
              style={{ maxWidth: 180 }}
            /> */}
          </div>
          <div className={styles.lang_select}>
            <GlobalOutlined />
            <Select
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              defaultValue={defaultLangValue()}
              bordered={false}
              onChange={onLangChange}
              fieldNames={false}
            >
              <Select.Option value="en_US">
                Intl-English
              </Select.Option>
              <Select.Option value="zh_CN">
                Intl-简体中文
              </Select.Option>
              {/* <Select.Option value="zh_XG">
                Intl-繁體中文
              </Select.Option> */}
            </Select>
          </div>
        </Layout.Header>
        <Layout.Content>
          <div className={styles.content}>
            {/* <div className={styles.left_box}> */}
            <div
              className={styles.form_box}
              style={{
                width: `${location.pathname === '/login/forgotPWD' ? '45%' : '30%'}`,
                minWidth: `${location.pathname === '/login/forgotPWD' ? '400px' : '350px'}`
              }}
            >
              <Routes>
                <Route path="*" element={<LoginForm />}></Route>
                {/* <Route path="/createAccount" element={<CreateAccountForm />}></Route> */}
                <Route path="/forgotPWD" element={<ForgotPWDForm />}></Route>
              </Routes>
            </div>
          </div>
        </Layout.Content>
      </Layout>
    </div>
  )
};

export default LoginLayout;
